"use client";

import type { BuilderBlock, BuilderContextInterface, RegisteredComponents } from "@builder.io/sdk-react";
import { Blocks } from "@builder.io/sdk-react";

import { ContactDetails as UIContactDetails } from "@jti/ui/eva-components/Footer/components/ContactDetails";

type ContactDetailsBuilderProps = {
  title: string;
  subTitle?: string;
  text?: string;
  builderBlock: BuilderBlock;
  builderContext: BuilderContextInterface;
  builderComponents: RegisteredComponents;
};

export function ContactDetails({
  title,
  subTitle,
  text,
  builderBlock,
  builderContext,
  builderComponents,
}: ContactDetailsBuilderProps) {
  return (
    <UIContactDetails title={title} subTitle={subTitle} text={text}>
      {builderBlock?.children?.map((child) => (
        <Blocks
          key={child.id}
          blocks={[child]}
          parent={builderBlock?.id}
          path="children"
          context={builderContext}
          registeredComponents={builderComponents}
        />
      ))}
    </UIContactDetails>
  );
}
